import { RootState, ShopState, AppointmentState } from "../../types";

/**
 * Selects the shops slice from the Redux store
 * @param state - The root Redux state
 * @returns The shops state
 */
export const selectShops = (state: RootState): ShopState => state.shops;

/**
 * Selects the appointments slice from the Redux store
 * @param state - The root Redux state
 * @returns The appointments state
 */
export const selectAppointments = (state: RootState): AppointmentState =>
  state.appointments;
